import domain from './domain';

// Reset open task list data
export const resetTeamOpenTaskListData = domain.createEvent('resetTeamOpenTaskListData');
